import Asap from './asap'
import Highlight from './highlight'
import Rsvp from './rsvp'
import ServiceEta from './service-eta'
// import ServiceDesc from './service-description'
import StaticLocations from './static-locations'
import ExtraStop from './extra-stop'
import Charter from './charter'
import Optin from './optin'
import mtech from './mtech'
import others from './others'
import map from './map'
import d2d from './d2d'
import flight from './flight'
import gozocabs from './gozocabs'
import lyft from './lyft'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    Asap.state,
    Highlight.state,
    Rsvp.state,
    ServiceEta.state,
    // ServiceDesc.state,
    StaticLocations.state,
    ExtraStop.state,
    Charter.state,
    Optin.state,
    mtech.state,
    others.state,
    map.state,
    d2d.state,
    flight.state,
    lyft.state,
    gozocabs.state
  ),
  mutations: Object.assign(
    Asap.mutations,
    Highlight.mutations,
    Rsvp.mutations,
    ServiceEta.mutations,
    // ServiceDesc.mutations,
    StaticLocations.mutations,
    ExtraStop.mutations,
    Charter.mutations,
    Optin.mutations,
    mtech.mutations,
    others.mutations,
    map.mutations,
    d2d.mutations,
    flight.mutations,
    lyft.mutations,
    gozocabs.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/reservation/index.js